import { render, staticRenderFns } from "./ehr-section-select.vue?vue&type=template&id=090e2c50"
import script from "./ehr-section-select.vue?vue&type=script&lang=js"
export * from "./ehr-section-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports